import { Component, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { QRCodeModule } from 'angularx-qrcode';

@Component({
    standalone: false,
    selector: 'app-qr-demo',
    templateUrl: 'qrcode.component.html',
    encapsulation: ViewEncapsulation.None,
})
export class QrCodeComponent {
    url = 'https://example.com';
}